export default __webpack_public_path__ + "static/media/suns_white.0d10503e.png";